import { apiFetch } from "./client.js";

export interface AccountPatchBody {
  otherIncomeCents?: number;
}

export interface AccountResponse {
  balanceCents: number;
  allowanceCents: number;
  otherIncomeCents: number;
}

export async function patchAccount(
  kidId: string,
  body: AccountPatchBody,
): Promise<AccountResponse> {
  return apiFetch<AccountResponse>(`/api/kids/${encodeURIComponent(kidId)}/account`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}
